import "../src/assets/components/adminpage.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faMessage } from "@fortawesome/free-solid-svg-icons";
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";
import { useAuth } from "./authprovider"; // Import the useAuth hook

function AdminPage() {
  const navigate = useNavigate();
  const [alluser, setAlluser] = useState("0");
  const [allofficer, setAllOfficer] = useState("0");
  const [allmen, setAllmen] = useState("0");
  const [allwomen, setAllwomen] = useState("0");
  const [unactiveuser, setUnactiveuser] = useState("0");
  const [newmeeting, setNewmeeting] = useState("0");
  const [isHamburgerClicked, setIsHamburgerClicked] = useState(false);
  const { logout } = useAuth(); // Destructure the logout function from useAuth

  const handleHamburgerClick = () => {
    setIsHamburgerClicked(!isHamburgerClicked);
  };

  useEffect(() => {
    axios
      .get("https://brgytracerappserver.onrender.com/adminpage")
      .then((response) => {
        setAlluser(response.data.alluser);
        setAllOfficer(response.data.allofficer);
        setAllmen(response.data.allmen);
        setAllwomen(response.data.allwomen);
        setUnactiveuser(response.data.newuser);
        setNewmeeting(response.data.newmeeting);
        // setLoading(false);
      })
      .catch((error) => {
        // setError(error);
        // setLoading(false);
      });
  }, []);

  const setmeeting = () => {
    navigate("/setmeeting");
  };
  const viewnewuser = () => {
    navigate("/newuser");
  };
  const viewnewmeeting = () => {
    navigate("/viewmeeting");
  };
  const showalluser = () => {
    navigate("/listalluser");
  };
  const viewrequest = () => {
    navigate("/viewrequest");
  };
  const Chatbot = () => {
    navigate("/chatbot");
  };
  const handleLogout = () => {
    logout(); // Call the logout function from useAuth to clear user data
  };
  return (
    <div className="adminpage-parent parent-height">
      <AutoLogout />
      <div className="admin-holder">
        <div
          id="hamburger"
          className={`header-area ${isHamburgerClicked ? "is-clicked" : ""}`}
          onClick={handleHamburgerClick}>
          <div className="hidden-menuBar">
            <div className="navigation"></div>
            <ul>
              <img src={logo} alt="" title="" width="100px" height="100px" />
              <li onClick={setmeeting}>setMeeting</li>
              <li onClick={showalluser}>Users</li>
              <li onClick={viewrequest}>View Request</li>
              <li onClick={Chatbot}>Chat</li>
              <li onClick={handleLogout}>Logout</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="meeting-and-newuser-container">
        <div className="left all-meeting-parent">
          <div>
            {/* <label>View</label> */}
            <li onClick={viewnewuser}>View</li>
            <FontAwesomeIcon icon={faUser} />
            <h5>{unactiveuser}</h5>
          </div>
        </div>
        <div className="left all-newuser-parent">
          <div>
            <li onClick={viewnewmeeting}>View</li>
            <FontAwesomeIcon icon={faMessage} />
            <h5>{newmeeting}</h5>
          </div>
        </div>
      </div>
      <div className="dashboard-parent wrap">
        <div className="dashhboard">
          <div className="child all-user-parent">
            <div>
              <label>User</label>
              <h3>{alluser}</h3>
            </div>
          </div>
          <div className="child all-Officer-parent">
            <div>
              <label>Officer</label>
              <h3>{allofficer}</h3>
            </div>
          </div>
          <div className="child all-men-parent">
            <div>
              <label>Men</label>
              <h3>{allmen}</h3>
            </div>
          </div>
          <div className="child all-Women-parent">
            <div>
              <label>Women</label>
              <h3>{allwomen}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
